<header class="appbar backgroundBlue">
  <div style="float: left; height: 100%;">
    <img src="/assets/images/movisat.png" class="movisatLogo" style="float:left;" />
    <div class="vertical-line" style="margin-left: 10px;"></div>
    <img src="assets/images/ecomaestro.png" class="aplicacionLogo"
      style="float: left;" />
  </div>
  <div style="float: left; color: white;">{{getEnvironment()}}</div>
  <div class="avatar">
    <div class="empresaNombre">TECNOMOVILIDAD, S. COOP. </div>
    <img id="popoverButton" src="/assets/images/usuario.png" class="avatarProfile" />
    <jqxPopover [theme]="environment.tema" [selector]="'#popoverButton'" [arrowOffsetValue]="50"
      [offset]="{ left: -50, top: 0 }">
      <div><b>TECNOMOVILIDAD, S.COOP.</b></div>
      <div></div>
      <hr />
      <div>
        <button class="enlace" role="link" (click)="endAppSession()">Cerrar sesión</button>
      </div><br>
    </jqxPopover>
  </div>
</header>